











import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const BankConfig = namespace('BankConfig');

@Component
export default class BankConfigConnector extends Vue {
  @BankConfig.State
  public useBigPay!: boolean;

  @BankConfig.State
  public useHengPay!: boolean;

  @BankConfig.State
  public useZappay!: boolean;

  @BankConfig.State
  public useBank!: boolean;
}
